import React, { useEffect, useState } from "react";

import { Helmet } from "react-helmet-async";
import api from "../../utilis/api";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Myorder = () => {
  const [orders, setOrders] = useState([]);
  const token = useSelector((state) => state.user.token) || "";
  const navigate = useNavigate();
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await api.get("/orders/", {
          headers: { authorization: `Bearer ${token}` },
        });

        setOrders(response.data.data);
      } catch (err) {
        console.error(err.response?.data || err);
      }
    };

    if (token) fetchOrders();
  }, [token]);

  return (
    <>
      <Helmet>
        <title>My Orders</title>
        <meta name="description" content="Welcome to My Orders page" />
      </Helmet>

      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-20 py-10 bg-gradient-to-b from-gray-50 to-white min-h-screen">
        {/* Header */}
        <div className="text-center mb-10">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-800">
            My Orders
          </h1>
          <p className="text-gray-500 mt-2 text-sm sm:text-base">
            Track your purchases and delivery status
          </p>
        </div>

        {/* Orders */}
        <div className="space-y-5">
          {orders && orders.length > 0 ? (
            orders.map((order) => (
              <div
                key={order._id}
                className="bg-white border border-gray-100 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 p-5 sm:p-6 flex flex-col sm:flex-row justify-between gap-5"
              >
                {/* Left Content */}
                <div className="flex flex-col gap-1">
                  <h1 className="text-lg font-semibold text-gray-800">
                    Order #{order.orderNo}
                  </h1>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-1 mt-2 text-sm text-gray-600">
                    <p>
                      <span className="font-medium text-gray-700">Total:</span>{" "}
                      ${order.totalPrice}
                    </p>

                    <p>
                      <span className="font-medium text-gray-700">
                        Shipping:
                      </span>{" "}
                      {order.shippingMethod}
                    </p>

                    <p>
                      <span className="font-medium text-gray-700">
                        Payment:
                      </span>{" "}
                      {order.paymentStatus}
                    </p>

                    <p>
                      <span className="font-medium text-gray-700">
                        Customer:
                      </span>{" "}
                      {order.user.name}
                    </p>
                  </div>
                </div>

                {/* Right Action */}
                <div className="flex sm:items-center justify-start sm:justify-end">
                  <button
                    onClick={() => navigate(`/user/order_detail/${order._id}`)}
                    className="bg-black text-white px-5 py-2 rounded-xl text-sm hover:bg-gray-800 active:scale-95 transition shadow-md"
                  >
                    Order Details
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="flex justify-center mt-12">
              <div className="bg-white border border-gray-100 shadow-sm rounded-2xl px-8 py-6 text-center">
                <p className="text-gray-700 font-medium">No orders found 📦</p>
                <p className="text-gray-500 text-sm mt-1">
                  Your order history will appear here
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Myorder;
